export enum SendEmailsTo {
  None = 'none',
  Default = 'default',
  SupplierAndDealer = 'supplier-and-dealer',
  DealerAndBuyerOnly = 'dealer-and-buyer-only',
}
